export const checkoutUrlBuilder = (campaignId, orgId, forwardCheckoutQueryParams, checkoutBaseUrl, {
  amount,
  frequency,
  recurringEndDate,
  currency,
  designationId
}, dedication, showDedication) => {
  const possibleQueryParams = {
    cid: campaignId ?? '',
    oid: orgId ?? '',
    amount,
    frequency,
    recurringEndDate,
    currency,
    designation: designationId ?? '',
    dedication: dedication ?? '',
    dedicationEnabled: showDedication && !dedication ? 'true' : ''
  };

  // * Strip out falsey Query Params
  const queryParams = Object.fromEntries(Object.entries(possibleQueryParams).filter(([, v]) => !['false', '0', '', undefined].includes(v)));
  const checkoutQueryParams = new URLSearchParams({
    ...queryParams,
    ...forwardCheckoutQueryParams
  });

  // * Return the final checkout URL
  return `${checkoutBaseUrl ?? ''}?${checkoutQueryParams}`;
};